export const getI18nGenre = (genre: string, i18n: any, genres: any) => {
  if (genre) {
    const genreI18n = genres.find((gen: any) => gen.code === genre);
    if (genreI18n) return genreI18n[`${i18n.language}`];
    return genre;
  }
  return "";
};
export const getLanguageGenre = (genre: string, language: any, genres: any) => {
  if (genre) {
    const genreI18n = genres.find((gen: any) => gen.code === genre);
    if (genreI18n) return genreI18n[`${language}`];
    return genre;
  }
  return "";
};

export const getI18nGenreByKey = (
  genre: string,
  i18n: any,
  genreByKeys: any
) => {
  if (genre) {
    const genreI18n = genreByKeys[genre];
    if (genreI18n) return genreI18n[i18n.language];
    return genre;
  }
  return "";
};
